import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from 'antd';

import BreakoutReportModal from './BreakoutReportModal';

import styles from '../Messages.module.scss';

const BreakoutReportWrapper = () => {
  const { t } = useTranslation('chat');

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div onClick={() => setOpenModal(true)} className={styles['breakout-report']}>
        <Typography.Text>{t('discussionResults')}</Typography.Text>
      </div>
      <BreakoutReportModal open={openModal} onCancel={() => setOpenModal(false)} />
    </>
  );
};

export default BreakoutReportWrapper;
